var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "video" } }, [
    _c(
      "div",
      {
        class: "youtube position-relative cursor-pointer video-" + _vm.videoId
      },
      [
        _c("div", {
          staticClass: "play-button cursor-pointer",
          attrs: { tooltip: "Video Starten" },
          on: {
            click: function($event) {
              return _vm.loadYoutubeVideo(_vm.videoId)
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "message" } }, [
      _vm._v(_vm._s(_vm.$translate("KrauseSohn::Template.youtubeDataTransfer")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }